import { formatToIso } from "@repo/utils";
import { hasItems } from "@repo/utils";
import useSWR from "swr";

import * as fetcher from "../fetcher";
import {
  type QuotationSearchProps,
  type QuotationsSearchResponse,
} from "./types";

export const stringifyQuotationQuery = (props?: QuotationSearchProps) => {
  if (!props) {
    return "";
  }
  const searchParams = new URLSearchParams();

  if (props.unitId?.length) {
    searchParams.set("buFilter", props.unitId.join(","));
  }
  if (props.email?.length) {
    searchParams.set("coworkerFilter", props.email.join(","));
  }
  if (props.quotationStatus?.length) {
    searchParams.set("statusFilter", props.quotationStatus.join(","));
  }
  if (props.quotationCustomerType?.length) {
    searchParams.set(
      "customerTypeFilter",
      props.quotationCustomerType.join(",")
    );
  }
  if (hasItems(props.quotationValue)) {
    const valueFilter = `${Math.floor(props.quotationValue[0])}-${Math.ceil(
      props.quotationValue[1]
    )}`;
    searchParams.set("valueFilter", valueFilter);
  }

  if (Array.isArray(props.createdDate) && hasItems(props.createdDate)) {
    if (props.createdDate?.[0] && props.createdDate?.[1]) {
      const formattedDates = props.createdDate.map((date) =>
        formatToIso(new Date(date))
      );
      const combinedDates = formattedDates.join("-");
      searchParams.set("dateCreatedFilter", combinedDates);
    }
  }

  if (Array.isArray(props.expiryDate) && hasItems(props.expiryDate)) {
    if (props.expiryDate?.[0] && props.expiryDate?.[1]) {
      const formattedDates = props.expiryDate.map((date) =>
        formatToIso(new Date(date))
      );
      const combinedDates = formattedDates.join("-");
      searchParams.set("dateExpiryFilter", combinedDates);
    }
  }
  if (props.assignedToTeam !== undefined) {
    searchParams.set("assignedToTeams", String(props.assignedToTeam));
  }
  if (props.teamId) {
    searchParams.set("teamsFilter", String(props.teamId));
  }

  if (props.departmentFilter?.length) {
    searchParams.set(
      "departmentFilter",
      props.departmentFilter.map(String).join(",")
    );
  }

  searchParams.set("pageIndex", String(props.pageIndex || 0)); // Default to page 0
  searchParams.set("pageSize", String(props.pageSize || 5)); // Default to 5 per page

  return searchParams.toString();
};

export function useQuotationWidgetSearch(searchSettings?: any) {
  const queryString = searchSettings
    ? stringifyQuotationQuery(searchSettings)
    : "";
  return useSWR<QuotationsSearchResponse>(
    searchSettings ? `/opportunities/quotations?${queryString}` : null,
    (url) => fetcher.core.get(url),
    { shouldRetryOnError: false, revalidateOnFocus: false }
  );
}
